/**
 * Pulls the most useful human-readable string out of whatever the HTTP / MSAL layer threw.
 * Order of preference: ProblemDetails fields, MSAL errorMessage, native Error.message, fallback.
 */
export function extractErrorMessage(error: unknown, fallback: string): string {
  if (!error) return fallback;
  if (typeof error === 'string') return error;
  if (typeof error !== 'object') return fallback;

  const get = (obj: unknown, key: string): unknown => {
    if (obj && typeof obj === 'object') return (obj as Record<string, unknown>)[key];
    return undefined;
  };
  const str = (v: unknown) => (typeof v === 'string' && v.trim()) ? v : null;

  // ASP.NET Core ProblemDetails (HttpErrorResponse.error is the parsed body)
  const inner = get(error, 'error');
  return (
    str(get(inner, 'detail')) ??
    str(get(inner, 'title')) ??
    str(get(inner, 'message')) ??
    str(inner) ??                       // string error body
    str(get(error, 'errorMessage')) ??  // MSAL
    str(get(error, 'message')) ??       // native Error
    fallback
  );
}
